import * as api from '../contactApi';
import { ActivateContact, contactActionCreators, ContactActionKeys } from '..';
import {
    call,
    put,
    select,
    takeEvery
    } from 'redux-saga/effects';
import { IState } from '../..';
import { uiActionCreators } from '../../ui';

function* activateContactSaga(action: ActivateContact) {
  yield put(uiActionCreators.showSpinnerDialog());
  yield call(api.activateContact, action.payload);
  const contact = yield select((state: IState) => state.contacts.hash[action.payload.contactId]);

  if (contact) {
    yield put(contactActionCreators.processContacts([{ ...contact, inactive: false }]));
  }
  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchActivateContact() {
  yield takeEvery(ContactActionKeys.ACTIVATE_CONTACT, activateContactSaga);
}
